import React from "react";
import ReviewSlider from "./ReviewSlider";

function Videosection() {
  return (
    <>
      
      <section className="hero-section row align-items-center my-5">
        {/* Left Panel */}

        <div className="col-md-12  left-panel  text-center">
          <ReviewSlider />
        </div>

        {/* Right Panel */}
        {/* <div className="col-md-6 right-panel p-sm-5">
          <div className="hero__media hero__media--16105224605606f7b5 desttopview desktop_hero_media">
            <video
              loading="lazy"
              loop
              muted
              autoPlay
              onCanPlay={(e) => e.target.play()}
              onLoadedMetadata={(e) => (e.target.muted = true)}
            >
              <source src="assets/video/desktop-video.mp4" type="video/mp4" />
            </video>
          </div>
        </div> */}
      </section>
    </>
  );
}

export default Videosection;
